import { render } from "./Success.vue?vue&type=template&id=b5005050"
const script = {}

import "./Success.vue?vue&type=style&index=0&id=b5005050&lang=css"
script.render = render

export default script